import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Button, Drawer, Message } from "@arco-design/web-react";
import ClipEditor from "@/components/business/ClipEditor";
import trackState from "@/stores/clipEditor/trackState";
import playerStore from "@/stores/clipEditor/player";
import { crop, getCropDetail } from "@/services/clip";
import { getSimpleMedia } from "@/services/createSpace/graphQ/getSimpleMedia";
import { parseUrl } from "@/utils/file";
import { VideoTrack } from "@/stores/clipEditor/class/VideoTrack";

export interface ClipDrawerProps {
  triggerBtn?: React.ReactNode;
  mark?: boolean; // 标记不真裁剪，只返回start, duration参数
  onOk?: (data?: any) => void;
  onCancel?: () => void;
}

export interface ClipDrawerRef {
  open: (data?: any) => void;
  close: () => void;
}
const ClipDrawer = forwardRef<ClipDrawerRef, ClipDrawerProps>((props, ref) => {
  const { triggerBtn, mark = false, onOk, onCancel } = props;
  const timer = useRef(null);
  const [visible, setVisible] = useState(false);
  const [material, setMaterial] = useState<any>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log(material);
    if (!visible) {
      trackState.resetState();
      setMaterial(null);
      clearTimeout(timer.current);
    }
  }, [visible]);

  useImperativeHandle(ref, () => ({
    open: async (data) => {
      console.log("open-------", data);
      setMaterial(data);
      setVisible(true);

      const { id, file, clip } = await parseUrl(data?.play_info?.play_url);
      const videoTrack = new VideoTrack(
        {
          id,
          url: URL.createObjectURL(file),
          name: data.name,
          format: file.type,
          width: clip.meta.width,
          height: clip.meta.height,
          duration: Math.round(clip.meta.duration / 1000 / 1000),
        },
        {
          start: 0,
          offsetL: data.clip?.offsetL,
          offsetR: data.clip?.offsetR,
          end: data.clip?.end,
        }
      );
      if (!trackState.trackList?.length) {
        trackState.addTrack(videoTrack);
      }

      // videoTrack.start = 0;
      // videoTrack.frameCount = data.clip?.frameCount;
      // trackState.updateTrack(0, 0, {
      //   offsetL: data.clip?.offsetL,
      //   offsetR: data.clip?.offsetR,
      // });
      videoTrack.resize({
        width: playerStore.playerConfig.playerWidth,
        height: playerStore.playerConfig.playerHeight,
      });
    },
    close: () => {
      setVisible(false);
    },
  }));

  return (
    <>
      {triggerBtn && (
        <div
          onClick={() => {
            setVisible(true);
          }}
        >
          {triggerBtn}
        </div>
      )}
      <Drawer
        unmountOnExit
        style={{ minWidth: "760px" }}
        width="50%"
        title={<span>视频裁剪</span>}
        visible={visible}
        onCancel={() => {
          setVisible(false);
          setLoading(false);
        }}
        footer={
          <>
            {mark && (
              <Button
                onClick={() => {
                  if (mark) {
                    const group = trackState.trackList?.[0]?.list?.[0];
                    trackState.updateTrack(0, 0, {
                      start: 0,
                      offsetL: 0,
                      offsetR: 0,
                      end: group.frameCount,
                    });
                  } else {
                    setLoading(false);
                    setVisible(false);
                    onCancel?.();
                  }
                }}
              >
                复原
              </Button>
            )}
            <Button
              type="primary"
              loading={loading}
              onClick={async () => {
                const group = trackState.trackList?.[0]?.list?.[0];
                console.log(group);
                const start = +((group.offsetL / 30) * 1000).toFixed(); // ms
                const end = +((group.offsetR / 30) * 1000).toFixed(); // ms
                const duration = +((group.end / 30) * 1000).toFixed();
                console.log(start, duration);

                if (!mark) {
                  setLoading(true);
                  const cropData = await crop({
                    material_id: material.id,
                    start,
                    duration,
                  });
                  console.log(cropData);

                  timer.current = setInterval(async () => {
                    const result = await getCropDetail(cropData?.data?.id);
                    console.log("result", result);

                    const status = result?.data?.status || 0;
                    if (status === 2) {
                      // loading
                    }
                    if (status === 3) {
                      //error
                      clearInterval(timer.current);
                      setLoading(false);
                      onOk(null);
                      Message.error(result?.data?.err_msg);
                      setVisible(false);
                    }
                    if (status === 4) {
                      clearInterval(timer.current);
                      const res = await getSimpleMedia(result?.data?.dest_id);
                      console.log("res========", res);

                      setLoading(false);
                      setVisible(false);
                      onOk(res);
                      Message.success({
                        content: "编辑成功，已保存为新视频",
                        duration: 3000,
                      });
                    }
                  }, 2000);
                } else {
                  onOk({
                    start,
                    end: group.end,
                    duration: Math.min(duration, material.duration),
                    offsetL: group.offsetL,
                    offsetR: group.offsetR,
                    cropped: group.end < group.frameCount,
                  });
                  setVisible(false);
                }
              }}
            >
              确定
            </Button>
          </>
        }
      >
        <ClipEditor />
      </Drawer>
    </>
  );
});

export default ClipDrawer;
